<template>
  <div>
    <div
      class="panel mt-20"
      style="display: flex; align-items: center; justify-content: space-between"
      v-if="!all"
    >
      <div style="display: flex; flex-wrap: wrap; gap: 10px">
        <el-tag
          type="primary"
          :effect="selected == index ? 'dark' : 'plain'"
          class="pointer"
          @click="handleSelectYear(index)"
          v-for="(item, index) in statistics"
          :key="index"
          >{{ item.year ? $time(item.year).format('YYYY年') : '全部' }}：￥{{
            item.commodity_amount.toFixed(2)
          }}</el-tag
        >
      </div>
      <MaintainanceRuleSelect
        v-model="filter.maintainance_rule_id"
        style="width: 220px"
      >
      </MaintainanceRuleSelect>
    </div>
    <div class="panel mt-20" v-else>
      <div class="filter">
        <el-form
          :model="filter"
          ref="filterForm"
          label-position="right"
          label-width="90px"
          @submit.native.prevent
        >
          <el-form-item label="保养内容">
            <MaintainanceRuleSelect
              v-model="filter.maintainance_rule_id"
              style="width: 220px"
            >
            </MaintainanceRuleSelect>
          </el-form-item>
          <el-form-item label="最终客户">
            <customer-select
              :val="filter.customer_id"
              @change="filter.customer_id = $event"
            ></customer-select>
          </el-form-item>
          <el-form-item label="保养状态" prop="status">
            <el-select v-model="filter.status" size="small">
              <el-option label="所有" :value="1" :key="1"></el-option>
              <el-option label="未完保" :value="0" :key="0"></el-option>
              <el-option label="已完保" :value="2" :key="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="计划保养日期" prop="date">
            <el-date-picker
              style="width: 360px"
              v-model="filter.date"
              type="daterange"
              size="small"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              :unlink-panels="true"
            ></el-date-picker>
          </el-form-item>
        </el-form>
        <div style="margin-left: 90px">
          <el-button type="primary" size="small" @click="getAllData()"
            >筛选</el-button
          >
          <el-button size="small" @click="getAllData(true)">重置</el-button>
        </div>
      </div>
    </div>

    <div class="panel mt-20">
      <el-table :data="list" stripe key="rules" v-loading="loading">
        <el-table-column
          prop="customer_device.serial_number"
          label="保养设备"
          min-width="120"
        ></el-table-column>
        <el-table-column
          prop="customer_device.customer.name"
          label="最终客户"
          min-width="120"
        >
          <template slot-scope="scope">
            <customer-link
              :customer="scope.row.customer_device.customer"
            ></customer-link>
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="保养内容"
          min-width="100"
        ></el-table-column>
        <el-table-column
          prop="start_date"
          label="计划保养日期"
          min-width="120"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="finish_date"
          label="完保日期"
          min-width="120"
          align="center"
          v-if="all"
        >
          <template slot-scope="scope">
            {{ scope.row.finish_date || '-' }}
          </template>
        </el-table-column>
        <el-table-column
          prop="commodity_amount"
          label="保养套餐价"
          min-width="100"
          align="center"
        >
          <template slot-scope="scope"
            >￥{{ scope.row.commodity_amount.toFixed(2) }}</template
          >
        </el-table-column>
        <el-table-column label="操作" width="160" align="center" v-if="all">
          <template slot-scope="scope">
            <template v-if="!scope.row.finish_date">
              <el-popconfirm
                class="mr-5"
                title="停止保养后该设备将不再发送通知和生成新的保养计划，确认停止吗？"
                @confirm="handleStopMaintainance(scope.row.id, scope.$index)"
                v-permission="Auth.customerDeviceMaintentanceUpdate"
              >
                <el-button slot="reference" type="text" size="mini"
                  >停止保养</el-button
                >
              </el-popconfirm>
              <el-button
                type="text"
                size="mini"
                @click="showFormer(scope.row)"
                v-permission="Auth.customerDeviceMaintentanceUpdate"
                >完保</el-button
              >
            </template>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-20"
        :page-size="filter.size"
        :current-page.sync="filter.page"
        layout="total, prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>

    <el-dialog title="完成保养日期" :visible.sync="dialogVisible" width="400px">
      <el-form
        ref="form"
        label-width="80px"
        :model="editModel"
        :rules="formRules"
      >
        <el-form-item label="计划日期">
          {{ editModel.start_date }}
        </el-form-item>
        <el-form-item label="完保日期" prop="finish_date">
          <el-date-picker
            style="width: 100%"
            size="small"
            v-model="editModel.finish_date"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="请选择"
          ></el-date-picker>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible = false">取 消</el-button>
        <el-button
          size="small"
          type="primary"
          :loading="submiting"
          @click="submitForm"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  customerDeviceMaintentance,
  maintainanceRuleList,
} from '../../service/getData'
import MaintainanceRuleSelect from '@/components/select/MaintainanceRuleSelect'
import CustomerSelect from '@/components/select/customer_select'

export default {
  components: { MaintainanceRuleSelect, CustomerSelect },
  props: {
    customerID: {
      type: Number,
      default: 0,
    },
    all: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      list: [],
      statistics: [],
      selected: 0,
      maintainance_rule_id: '',
      total: 0,
      filter: {
        size: 10,
        page: 1,
        status: 0,
        customer_id: this.customerID,
        is_customer_maintainance: true,
        maintainance_rule_id: '',
        year: '',
        date: '',
      },
      loading: false,
      submiting: false,
      dialogVisible: false,
      editModel: {
        id: 0,
        start_date: '',
        finish_date: '',
      },
      formRules: {
        finish_date: [
          { required: true, message: '请选择日期', trigger: 'change' },
        ],
      },
    }
  },
  watch: {
    customerID: function () {
      if (this.customerID) {
        this.requestCustomerMaintainanceList()
      }
    },
    'filter.page': function () {
      this.requestCustomerMaintainanceList()
    },
    'filter.maintainance_rule_id': function () {
      if (!this.all) {
        this.filter.page = 1
        this.filter.year = ''
        this.selected = 0
        this.requestCustomerMaintainanceList(true)
        this.requestCustomerMaintainanceList()
      }
    },
  },
  created() {
    if (this.all) {
      if (this.$route.query.from == 'msg') {
        const start = new Date()
        const end = new Date(start) // 创建一个新日期对象，复制今天的所有信息
        end.setDate(start.getDate() + 30)
        let t1 = this.$time(start).format('YYYY-MM-DD')
        let t2 = this.$time(end).format('YYYY-MM-DD')
        this.filter.date = [t1, t2]
      }
      this.getAllData()
    } else {
      this.requestCustomerMaintainanceList(true)
      this.requestCustomerMaintainanceList()
    }
  },
  methods: {
    showFormer(rule) {
      this.editModel = {
        id: rule.id,
        start_date: rule.start_date,
        finish_date: '',
      }
      this.dialogVisible = true
    },
    submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.submiting = true
          let res = await customerDeviceMaintentance(this.editModel)
          if (res.code == 0) {
            this.getAllData()
          }
          this.submiting = false
          this.dialogVisible = false
        } else {
          this.submiting = false
          return false
        }
      })
    },
    async handleStopMaintainance(id = 0) {
      let res = await customerDeviceMaintentance({
        id: id,
        stop: true,
      })
      if (res.code == 0) {
        this.getAllData()
      }
    },
    getAllData(reset = false) {
      this.filter.page = 1
      if (reset) {
        this.filter.status = 1
        this.filter.date = ''
        this.filter.maintainance_rule_id = ''
        this.filter.customer_id = ''
      }
      this.requestCustomerMaintainanceList()
    },
    async requestCustomerMaintainanceList(is_statistic = false) {
      if (!this.filter.customer_id && !this.all) return
      let data = this.clone(this.filter)
      if (data.date && data.date.length == 2) {
        data.start_day = data.date[0] || ''
        data.end_day = data.date[1] || ''
      }
      data.page -= 1
      data.is_statistic = is_statistic
      this.loading = true
      let res = await maintainanceRuleList(data)
      if (is_statistic) {
        this.grouyMaintainance(res.data.list)
        return
      }
      this.list = res.data.list
      this.total = res.data.total
      this.loading = false
    },

    async handleSelectYear(index) {
      this.selected = index
      let item = this.statistics[index]
      this.filter.page = 1
      this.filter.year = item.year
      this.requestCustomerMaintainanceList()
    },

    grouyMaintainance(list = []) {
      let total = 0
      list.map((item) => {
        total += item.commodity_amount
      })

      list.unshift({
        year: '',
        commodity_amount: total,
      })
      this.statistics = list
    },
  },
}
</script>